import { useState, useEffect, useRef } from 'react';
import './App.css';
import Map from './components/map/Map';
import FPECrossSection from "./components/crosssection/FPECrossSection";
import Header from "./components/header/Header";
import TimeController from "./components/TimeController";
import Footer from "./components/Footer";
import PlanEditorPanel from "./components/plan_editor/PlanEditorPanel";
import { useLayoutState } from "./store/LayoutState";
import useEffectSkipFirst from "./hooks/useEffectSkipFirst";

function App() {

  const {layout, isHorizontal, isVertical} = useLayoutState();
  const [crossSectionSize, setCrossSectionSize] = useState();

  const isFirstRender = useRef(false)

  useEffect(() => {
    isFirstRender.current = true
  }, [])

  useEffect(() => {
    if (isFirstRender) {
      initResizer();
      isFirstRender.current = false;
    }
  });

  useEffectSkipFirst(() => {
    const mapWrap = document.getElementById('map-wrap');
    mapWrap.style.width = null;
    mapWrap.style.height = null;
    setCrossSectionSize({});
  }, layout);

  function initResizer() {
    const pageWrap = document.getElementById('page');
    const mapWrap = document.getElementById('map-wrap');
    const resizer = document.getElementById('resizer');
    resizer.onmousedown = () => {
      document.addEventListener('mousemove', resize);
      document.addEventListener('mouseup', onMouseUp);
      const pageHeight = pageWrap.clientHeight;
      function resize(e) {
        mapWrap.style.userSelect = 'none';
        let csSize = {}
        if (isHorizontal) {
          let h = mapWrap.clientHeight + e.movementY;
          if (h > pageHeight) {
            h = pageHeight;
          }
          mapWrap.style.height = h + 'px';
          csSize.height = pageHeight - h - resizer.clientHeight;
        } else if (isVertical) {
          let w = mapWrap.clientWidth + e.movementX;
          mapWrap.style.width = `${w}px`;
          csSize.width = pageWrap.clientWidth - w - resizer.clientWidth;
        }
        setCrossSectionSize(csSize);
      }

      function onMouseUp() {
        mapWrap.style.userSelect = 'auto';
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', resize);
      }
    }
  }

  return (
    <div id="app" className={`App ${layout}`}>
      <Header/>
      <div id="page-wrap" className="page-wrap">
        <div id="page" className="page">
          <div id="map-wrap" className="map-wrap">
            <Map/>
            <PlanEditorPanel/>
          </div>
          <div id="resizer" className="resizer"/>
          <div className="cross-wrap">
            <FPECrossSection crossSectionSize={crossSectionSize}/>
          </div>
        </div>
      </div>
      <div className="time-controller-wrap">
        <TimeController/>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
